export const CONTEXTMENU_EVENT_NAME = 'contextmenu'
